import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
//import { createLogger } from "redux-logger";
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from '../reducers/reducers'

import axiosMiddleware from 'redux-axios-middleware';
import api from '../middleware/api';
import isEmpty from 'lodash.isempty';
import pick from 'lodash.pick';

const crashReporter = store => next => action => {
  try {
    return next(action); // dispatch
  } catch (err) {
    console.error('Caught an exception!', err);
    throw err; // re-throw error
  }
}


/*const appReducer = combineReducers({
	//...reducers,
	router: routerReducer
});*/

const initialState = {};

const history = createBrowserHistory();
//const logger = createLogger();
//const history = createHistory()
const appReducer = createRootReducer(history);

const retainKeys = ['auth', 'properties', 'property_types', 'timezones', 'reservation_units', 'countries', 'board_types', 'currencies', 'reservation_statuses'];

const rootReducer = ( state, action ) => {
	if ( action.type === 'LOGOUT' && state ) {
		//console.log('LOGOUT', state);
		state = undefined;
	}else if ( action.type === 'ACTIVE_PROPERTY' && state ) {
		//console.log('LOGOUT', state);
		//state = undefined;
		state = !isEmpty(retainKeys) ? pick(state, retainKeys) : undefined;
	}
	  
	return appReducer(state, action)
}

const middlewares = [
	routerMiddleware(history), // for dispatching history actions
	thunkMiddleware, 
	axiosMiddleware(api),
	//logger,
	crashReporter
];

if (process.env.NODE_ENV === `development`) {
  const { logger } = require(`redux-logger`);
  middlewares.push(logger);
}

export default function configureStore() {
	let store;

	if (module.hot) {
		store = createStore(
            //createRootReducer(history), // root reducer with router state
            rootReducer,
			initialState,
			compose(
				applyMiddleware(
					...middlewares
				),
				window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
			),
		)
    /*store = createStore(
      //connectRouter(history)(rootReducer),
      rootReducer,
      initialState,
      compose(
        applyMiddleware(routerMiddleware(history), thunkMiddleware, axiosMiddleware(api), logger, crashReporter),
        window.devToolsExtension ? window.devToolsExtension() : f => f
      )
    );*/
  } else {
		store = createStore(
            //createRootReducer(history), // root reducer with router state
            rootReducer,
			initialState,
			compose(
				applyMiddleware(
					...middlewares
				),
				f => f
			),
		)
    /*store = createStore(
      //connectRouter(history)(rootReducer),
      rootReducer,
      initialState,
      compose(applyMiddleware(routerMiddleware(history), thunkMiddleware, axiosMiddleware(api), crashReporter), f => f)
    );*/
  }

  return store;
}